import React, { PureComponent } from 'react';
import { createSelector } from 'reselect';
import { utcFormat, utcDay } from 'd3'
import Selector from './Selector';
import DatePicker from './DatePicker'
import { periods } from './periods';
import { translate } from './translate';

const availableTimePeriods = createSelector(
  props => props.availableTimeRange,
  ([firstDate, latestDate]) => {
    return [
      '1W','1M','3M','6M','1Y','3Y','5Y','10Y','YTD','INC', 'CUSTOM'
    ].filter(period => period === 'INC' || period === 'CUSTOM' || periods[period](latestDate) > firstDate)
  }
)

const periodIdWithLabel = createSelector(
  props => props.i18n,
  props => props.lang,
  (props, state) => state.customRange,
  (props, state) => state.customEditState,
  (i18n, lang, customRange, customEditState) => id => {
    if (id === 'CUSTOM') {
      const [ date0, date1 ] = customRange
      const formatDate = utcFormat('%x')
      return {
        id,
        label: date0 === null && date1 === null ? translate('CUSTOM', i18n, lang) : formatDate(date0) + ' - ' + (date1 === null ? '' : formatDate(date1)),
        customClassName: `PeriodSelector-custom-range-option ${customEditState !== OFF ? 'in-edit' : ''}`
      }
    }
    else {
      return { id, label: translate(id, i18n, lang) }
    }
  }
)

const [OFF, DATE0, DATE1] = ['off', 'date0', 'date1']

class PeriodSelector extends PureComponent {
  constructor() {
    super()
    this.state = {
      customRange: [null, null],//[new Date(2017, 2, 1), new Date(2017, 5, 1)],
      customEditState: OFF // or DATE0, DATE1
    }
    this.handleSubmitCustomDate0 = this.handleSubmitCustomDate0.bind(this)
    this.handleSubmitCustomDate1 = this.handleSubmitCustomDate1.bind(this)
    this.handleSelected = this.handleSelected.bind(this)
  }
  handleSelected(selectedPeriod) {
    const { selected, onSelect } = this.props

    if (selectedPeriod === 'CUSTOM') {
      const { customRange } = this.state
      const [ date0, date1 ] = customRange
      if (selected === selectedPeriod || (date0 === null && date1 === null)) {
        this.setState({ customEditState: DATE0, customRevertRange: customRange })
      }
      else {
        onSelect(selectedPeriod, customRange)
      }
    }
    else {
      this.setState( { customEditState: OFF })
      onSelect(selectedPeriod)
    }
  }
  gotoEditState(targetState) {
    return () => this.setState({ customEditState: targetState})
  }

  handleSubmitCustomDate0(date0) {
    const { customRange } = this.state
    const newRange = [date0, customRange[1]]
    this.setState({
      customRange: newRange,
      customEditState: DATE1
    })
  }
  handleSubmitCustomDate1(date1) {
    const { onSelect } = this.props
    const { customRange } = this.state
    const newRange = [
      new Date( Math.min(utcDay.offset(date1, -7), customRange[0]) ), 
      date1
    ]
    this.setState({
      customRange: newRange,
      customEditState: OFF
    })
    onSelect('CUSTOM', newRange)
  }
  render() {
    const {selected, availableTimeRange } = this.props
    const { customEditState, customRange, customRevertRange } = this.state
    const [date0, date1] = customRange
    return (
      <div className='DatePicker-container'>
        <Selector
          options={availableTimePeriods(this.props, this.state).map(periodIdWithLabel(this.props, this.state))}
          onSelect={this.handleSelected}
          selected={selected}
        />
        {
          customEditState === OFF
          ? null
          : <DatePicker
              selectedDate={
                customEditState === DATE0 
                ? date0 || new Date( Math.max(availableTimeRange[0], periods[selected](availableTimeRange[1])) )
                : date1 || availableTimeRange[1]}
              availableTimeRange={availableTimeRange}
              message={`Select the ${customEditState === DATE0 ? 'START' : 'END'} date...`}
              onSubmit={customEditState === DATE0 ? this.handleSubmitCustomDate0 : this.handleSubmitCustomDate1}
              onCancel={() => this.setState({ customEditState: OFF, customRange: customRevertRange })}
            />
        }
      </div>  
    )
  }
}

export default PeriodSelector


// WEBPACK FOOTER //
// ./src/PeriodSelector.js